var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _vm.tagList ? _c('div', { ref: "tagContainer", staticClass: "tag-container" }, [_c('div', { staticClass: "tag-list clearfix" }, _vm._l(_vm.tagList, function (tag) {
    return _c('a', { key: tag.id, ref: "tag", refInFor: true, staticClass: "tag-button", class: { 'is-current': _vm.currentTag === tag.id }, on: { "click": function click($event) {
          $event.preventDefault();return _vm.changeTag(tag);
        } } }, [_vm._v("\n      " + _vm._s(tag.name) + "\n    ")]);
  }), 0)]) : _vm._e();
};
var staticRenderFns = [];

export { render, staticRenderFns };